<div id="drug-distribution-chart">
  <div class="chart-header">
    <div class="chart-header-text-container">
      <span class="chart-title">
        {{ chartTitle }}
        <i *ngIf="dataSettings.revision" class="subScript"
          >as of {{ dataSettings.revisionDate }}</i
        >
      </span>
      <span class="subHeader">
        Displaying {{ selectedBrokerId.length - 2 }} out of
        {{ brokerCount }} estimated brokers
      </span>
    </div>
    <div class="chart-button-container">
      <div id="sourcesDropdown">
        <va-button
          btnType="outline"
          size="small"
          nz-dropdown
          [nzBackdrop]="true"
          nzTrigger="click"
          [nzDropdownMenu]="Sourcesmenu"
          #dropdown="nzDropdown"
          (nzVisibleChange)="dropdown.nzVisible ? (searchTerm = '') : null"
          [nzClickHide]="false"
        >
          Sources
          <va-icon size="small" name="chevron-down"></va-icon>
        </va-button>
        <nz-dropdown-menu #Sourcesmenu="nzDropdownMenu">
          <div style="max-height: 300px; background: white">
            <div class="distribution-category-searchbox">
              <nz-input-group nzSize="large" [nzPrefix]="prefixIcon">
                <input
                  class="distribution-search-input category"
                  #inputElement
                  nz-input
                  nzSize="small"
                  type="text"
                  placeholder="Search"
                  [(ngModel)]="searchTerm"
                  (ngModelChange)="searchAllBrokers($event)"
                />
                <!-- [(ngModel)]="facetCategorySearch[panel.key]"
                  (keyup)="onFacetCategorySearch(panel)" -->
              </nz-input-group>
              <ng-template #prefixIcon>
                <va-icon
                  size="small"
                  name="search"
                  class="search-icon"
                ></va-icon>
              </ng-template>
            </div>
            <ul nz-menu style="max-height: 200px; overflow-y: scroll">
              <li
                nz-menu-item
                *ngFor="
                  let colKey of searchTerm ? filteredBrokers : brokerList;
                  let i = index
                "
              >
                <label
                  nz-checkbox
                  [(ngModel)]="colKey.checked"
                  [nzDisabled]="colKey.disabled"
                  (ngModelChange)="onCheckboxChange(colKey, colKey.checked, i)"
                >
                  {{ colKey.name }}
                  <span *ngIf="colKey.exclude" class="excluded-container">
                    <nz-tag [nzColor]="'#E9EBEE'" class="excluded-tag"
                      >Ex</nz-tag
                    >
                  </span>
                </label>
              </li>
              <li
                nz-menu-item
                *ngIf="searchTerm && filteredBrokers.length === 0"
              >
                No results found.
              </li>
            </ul>
            <div class="sources-footer">
              <div class="footer-text">
                <span *ngIf="excludedBrokers.length > 0">
                  (Ex): Excluded from consensus
                </span>
              </div>
              <div class="footer-button">
                <va-button btnType="text" size="small" (click)="onChartReset()">
                  <va-icon size="small" name="redo"></va-icon>
                  <span> Reset </span>
                </va-button>
              </div>
            </div>
          </div>
        </nz-dropdown-menu>
      </div>
      <div id="downloadButtonDiv">
        <va-button
          btnType="outline"
          size="small"
          nz-dropdown
          [nzBackdrop]="false"
          nzTrigger="click"
          [nzDropdownMenu]="menu"
          [isOnlyIcon]="true"
        >
          <va-icon size="small" name="download"></va-icon>
        </va-button>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu>
            <li nz-menu-item class="download-opt" (click)="downloadValue(0)">
              Download PNG
            </li>
            <li nz-menu-item class="download-opt" (click)="downloadValue(2)">
              Download PDF
            </li>
          </ul>
        </nz-dropdown-menu>
      </div>
    </div>
  </div>
  <div class="chart-container">
    <highcharts-chart
      [Highcharts]="highcharts"
      [options]="chartOptions"
      [(update)]="updateFlag"
      style="width: 100%; height: 400px; display: block; padding-left: 180px"
      (chartInstance)="onHighchartsChartInstance($event)"
    >
    </highcharts-chart>
    <div
      id="charts-error"
      class="error-container"
      *ngIf="chartReady && showError"
    >
      <div class="error-msg">
        <va-icon name="info-circle" class="info-icon" size="small"></va-icon>
        <span class="error-text">{{
          errorMessage ? errorMessage : "Something went wrong!"
        }}</span>
      </div>
    </div>
  </div>
  <div class="chart-toggle">
    <p class="toggle-text">Accessibility</p>
    <nz-switch
      nzSize="small"
      [(ngModel)]="switchValue"
      (ngModelChange)="onSwitchChange($event)"
    ></nz-switch>
  </div>
</div>
